
import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import { Getter, Mutation, Action } from 'vuex-class'
import { TranslationHandler } from '../mixins/TranslationHandler'
import Services from './Services.vue'

@Component({
  components: { Services },
})
export default class AppHeader extends Mixins(TranslationHandler) {
  @Prop({ default: false }) isLogoShown!: boolean

  @Getter visualIsDark!: string
  @Getter visualPrimaryColor!: string
  @Getter visualHeaderImageUrl!: string
  @Getter visualLogoImageUrl!: string
  @Getter visualFont!: string

  @Getter isMobile!: boolean
  @Getter visualHeaderElementsAsList!: boolean

  get showHeader(): boolean {
    return this.isMobile === true || this.isLogoShown === false // hide header desktop chat papge
  }

  get style() {
    return {
      background: this.visualIsDark ? '#000' : this.visualPrimaryColor,
      color: this.color,
    }
  }

  get color() {
    return this.visualIsDark ? '#fff' : '#000'
  }
}
